/**
 * Reusable stateless form component for UserNode
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import form components
import { TextInput } from '../../../global/components/forms';

function UserNodeForm({
  cancelLink
  , formTitle
  , formType
  , handleFormChange
  , handleFormSubmit
  , userNode
}) {

  // set the button text
  const buttonText = formType === "create" ? "Create User Node" : "Update User Node";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="userNodeForm" className="userNode-form" onSubmit={handleFormSubmit}>
            {header}
            <TextInput
              change={handleFormChange}
              label="Name"
              name="name"
              placeholder="Name (required)"
              required={true}
              value={userNode.name}
            />
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                <button className="yt-btn " type="submit" > {buttonText} </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

UserNodeForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , userNode: PropTypes.object.isRequired
}

UserNodeForm.defaultProps = {
  formTitle: ''
}

export default UserNodeForm;



// WEBPACK FOOTER //
// modules/userNode/components/UserNodeForm.js.jsx